import { Plugin as ProseMirrorPlugin, TextSelection, AllSelection, NodeSelection, } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { history } from 'prosemirror-history';
import { dropCursor } from 'prosemirror-dropcursor';
import { gapCursor } from '../gapcursor/index.js';
import { handlePaste } from './callbacks.js';
import { renderAttrsToAttributes } from '../utils/schema.js';
import { truthy } from '../utils/truthy.js';
import { createProseMirrorPluginByStyles } from '../utils/styles.js';
import { builtInStyle } from './style.js';
export const createBuiltInProseMirrorPlugins = (config) => [
    history(),
    dropCursor(),
    gapCursor(),
    config.historyPreserveItems &&
        new ProseMirrorPlugin({
            historyPreserveItems: true,
        }),
    createProseMirrorPluginByStyles('exeditor-built-in', builtInStyle),
    new ProseMirrorPlugin({
        props: {
            handlePaste,
            attributes: { 'data-exeditor-root': '' },
        },
    }),
    new ProseMirrorPlugin({
        props: {
            decorations(state) {
                const { doc, selection } = state;
                const decos = [];
                if (selection instanceof NodeSelection) {
                    decos.push(Decoration.node(selection.from, selection.to, {
                        class: 'excore-selected-node',
                    }));
                }
                if (selection instanceof TextSelection ||
                    selection instanceof AllSelection) {
                    const { ranges } = selection;
                    ranges.forEach((range) => {
                        doc.nodesBetween(range.$from.pos, range.$to.pos, (node, pos) => {
                            if (node.type.name === 'text') {
                                return;
                            }
                            // 局部在 selection 中的不算
                            if (pos < range.$from.pos ||
                                pos + node.nodeSize >
                                    range.$to.pos + (node.isTextblock ? 1 : 0)) {
                                return;
                            }
                            const defaultClass = 'excore-in-selection';
                            const { inSelectionClass } = node.type.spec;
                            if (inSelectionClass) {
                                decos.push(Decoration.node(pos, pos + node.nodeSize, {
                                    class: inSelectionClass === true
                                        ? defaultClass
                                        : inSelectionClass,
                                }));
                            }
                            else if (node.isAtom) {
                                decos.push(Decoration.node(pos, pos + node.nodeSize, {
                                    class: defaultClass,
                                }));
                            }
                        });
                    });
                }
                return DecorationSet.create(doc, decos);
            },
        },
    }),
    new ProseMirrorPlugin({
        props: {
            decorations(state) {
                const { doc } = state;
                const decos = [];
                doc.descendants((node, pos) => {
                    if (!node.type.spec.renderAttrsToEditView) {
                        return;
                    }
                    decos.push(Decoration.node(pos, pos + node.nodeSize, renderAttrsToAttributes(node)));
                });
                return DecorationSet.create(doc, decos);
            },
        },
    }),
].filter(truthy);
//# sourceMappingURL=prosemirror-plugins.js.map